<!-- begin breadcrumb -->
<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item">Administración</li>
    <li class="breadcrumb-item active">Bancos</li>
</ol>
<!-- end breadcrumb -->
<!-- begin page-header -->
<h1 class="page-header"><i class="fas fa-wrench"></i> Administración <small> Bancos</small></h1>
<!-- end page-header -->

<div>
    <panel [noButton]="true">
        <h5>Listado de Bancos</h5>
        <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3">
            <div class="d-flex gap-2 flex-wrap align-items-center">
                <input type="text" class="form-control form-control-sm" style="width: auto; min-width: 220px;"
                    placeholder="Escriba para buscar" [(ngModel)]="nameBank" (keyup)="filterBanks()">
            </div>
            <button class="btn btn-success btn-xs flex-shrink-0" (click)="editBank = null; open(modalNewBank)">
                <i class="fas fa-plus"></i> Nuevo</button>
        </div>
        <div class="row mt-3 p-3 table-wrapper">
            <div class="table-responsive">
            <table class="table table-sm table-hover">
                <thead class="fixed-header">
                    <tr>
                        <th>N°</th>
                        <th>Nombre</th>
                        <th class="col-1 text-center">Código</th>
                        @if(permissions?.search.edit){
                        <th class="text-center"><i class="fas fa-cogs"></i></th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @if(listBanks.length > 0){
                    @for( b of listBanks; track b; let i = $index){
                    <tr [ngClass]="{'table-danger': !b.enabled}">
                        <td>{{ i + 1 }}</td>
                        <td>{{b.name | uppercase}}</td>
                        <td class="text-center">{{b.code}}</td>
                        @if(permissions?.search.edit){
                        <td class="text-center">
                            <button class="btn btn-warning btn-xs btn-rounded"
                                    (click)="editBank = b; open(modalNewBank)"><i class="fas fa-edit"></i></button>
                        </td>
                        }
                    </tr>
                    }
                    }@else{
                    <td colspan="4">No hay registros para mostrar.</td>
                    }
                </tbody>
            </table>
            </div>
        </div>
    </panel>
</div>

<ng-template #modalNewBank>
    <app-modal-bank [bank]="editBank" (bank_save)="getBanks($event)"
        [permissions]="permissions"></app-modal-bank>
</ng-template>